"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditLinePeriodModel = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const legacy_enums_2 = require("@daytrip/legacy-enums");
const legacy_transformers_1 = require("@daytrip/legacy-transformers");
const class_validator_1 = require("class-validator");
class CreditLinePeriodModel {
}
exports.CreditLinePeriodModel = CreditLinePeriodModel;
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    __metadata("design:type", String)
], CreditLinePeriodModel.prototype, "_id", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    __metadata("design:type", String)
], CreditLinePeriodModel.prototype, "creditLineId", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(legacy_enums_2.CreditLinePartnerType),
    __metadata("design:type", Number)
], CreditLinePeriodModel.prototype, "partnerType", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreditLinePeriodModel.prototype, "partnerId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], CreditLinePeriodModel.prototype, "creditLineAmount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], CreditLinePeriodModel.prototype, "temporaryAdjustmentAmount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], CreditLinePeriodModel.prototype, "remainingCreditLineAmount", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    __metadata("design:type", Number)
], CreditLinePeriodModel.prototype, "creditLineCurrency", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(legacy_enums_1.CreditLinePeriodUnit),
    __metadata("design:type", Number)
], CreditLinePeriodModel.prototype, "periodUnit", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(1),
    __metadata("design:type", Number)
], CreditLinePeriodModel.prototype, "periodLength", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    legacy_transformers_1.TransformToDate,
    __metadata("design:type", Date)
], CreditLinePeriodModel.prototype, "periodStart", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    legacy_transformers_1.TransformToDate,
    __metadata("design:type", Date)
], CreditLinePeriodModel.prototype, "periodEnd", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], CreditLinePeriodModel.prototype, "initialCreditUsed", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], CreditLinePeriodModel.prototype, "endCreditUsed", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], CreditLinePeriodModel.prototype, "amountInvoiced", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], CreditLinePeriodModel.prototype, "valueOfNewBookings", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], CreditLinePeriodModel.prototype, "valueOfCancelledBookings", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], CreditLinePeriodModel.prototype, "isClosed", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    __metadata("design:type", Object)
], CreditLinePeriodModel.prototype, "warningsRaised", void 0);
//# sourceMappingURL=credit-line-period.model.js.map